<template>
    <div>
        <h1 class="page-title">{{ $t('deals.TITLE') }}<br>
            <small>{{ $t('deals.DESCRIPTION') }}</small>
        </h1>

        <div class="row">
            <div class="col-md-12">

                <div class="portlet-body">
                    <div class="row">
                        <div class="col-md-12">
                            <div class="portlet light portlet-fit bordered">
                                <div class="portlet-title">
                                    <div class="caption">
                                        <i class="icon-speedometer font-green-haze"></i>
                                        <span class="caption-subject font-green-haze bold uppercase">{{ $t('deals.TOTAL_STATS') }}</span>
                                    </div>
                                </div>
                                <div class="portlet-body">
                                    <div class="row">
                                        <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12">
                                            <v-stats icon="fa fa-comments" :value="stats.lifetimeClaims"
                                                     :desc="$t('deals.CLAIMS_STATS')"
                                                     color="green"></v-stats>
                                        </div>
                                        <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12">
                                            <v-stats icon="fa fa-bar-chart-o" :value="stats.lifetimeTrx"
                                                     :desc="$t('deals.TRX_STATS').replace(/#.*?#/, getConversionRate())"
                                                     color="blue"></v-stats>
                                        </div>
                                        <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12">
                                            <v-stats icon="fa fa-shopping-cart" :value="stats.lifetimeSales"
                                                     :desc="$t('deals.SALES_STATS')"
                                                     color="red"
                                                     prefix="$"></v-stats>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-md-12">
                <div class="portlet light portlet-fit bordered">
                    <div class="portlet-title">
                        <div class="caption">
                            <i class=" icon-layers font-green"></i>
                            <span class="caption-subject font-green bold uppercase">{{ $t('deals.TAB_DEALS') }}</span>
                        </div>
                    </div>
                    <div class="portlet-body">
                        <div class="mt-element-card flex mt-element-overlay">
                            <v-deal-card v-for="deal in deals" :key="deal.id"
                                         :dealId="deal.id"
                                         :title="deal.title"
                                         :description="deal.description|truncate(150)"
                                         :img="deal.images[0].url"
                                         :status="deal.status == 1 ? status.active : status.ended"
                                         :dealData="deal"
                            ></v-deal-card>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
  /* ============
   * Deals Page
   * ============
   *
   */
  import * as appMutations from '@/app/store/modules/app/mutation-types'
  import CheckUserInfoMixin from '@/app/mixins/check-userinfo'
  import GeneralStatsTransformer from '@/app/transformers/GeneralStatsTransformer'
  import DealTransformer from '@/app/transformers/DealTransformer'
  import VDealCard from '@/app/components/DealCard'
  import VStats from '@/app/components/Stats'

  export default {
    /**
     * The name of the page.
     */
    name: 'deals-index',
    mixins: [CheckUserInfoMixin],
    data () {
      return {
        stats: {
          lifetimeAvg: 0,
          lifetimeClaims: 0,
          lifetimeSales: 0,
          lifetimeTrx: 0
        },
        deals: [],
        status: {
          active: 'STATUS_ACTIVE',
          ended: 'STATUS_ENDED'
        }
      }
    },
    components: {
      VDealCard,
      VStats
    },
    methods: {
      getConversionRate () {
        return this.stats.lifetimeTrx
          ? (this.stats.lifetimeTrx / this.stats.lifetimeClaims * 100).toFixed(0)
          : 0
      },
      async getUserDeals ({locale}) {
        const res = await this.$api.useroffersUserIdGet({
          'user_id': this.$store.state.account.id,
          'lang': locale,
          'offer_id': null
        })
        this.deals = DealTransformer.fetchCollection(res.data)
        return this.deals
      },
      async updateMerchantLocations (deals) {
        const merchantLocations = await Promise.all(deals.map(deal => {
          return this.$api.offerlocationsDealIdGet({
            'deal_id': deal.id
          })
        }))
        const merchantLocationsByDeal = {}
        deals.forEach((deal, idx) => {
          merchantLocationsByDeal[deal.id] = merchantLocations[idx].data
        })

        this.$store.commit(`app/${appMutations.MERCHANT_LOCATIONS}`, merchantLocationsByDeal)
      }
    },
    created () {
      this.getUserDeals({
        locale: this.$i18n.locale
      })
        .then(res => {
          this.updateMerchantLocations(this.deals)
        })
        .catch(err => {
          console.log(err)
          this.$notify.error({
            title: 'Error',
            message: 'Error occured.'
          })
        })

      this.$api.userstatsIdGet({
        id: this.$store.state.account.id
      })
        .then(res => {
          this.stats = Object.assign({}, this.stats, GeneralStatsTransformer.fetch(res.data))
        })
        .catch(err => console.log(err))

      // reload deals on locale change
      const vm = this
      this.$store.watch(
        function (state) {
          return state.locale.current
        },
        function (val) {
          vm.getUserDeals({
            locale: val
          })
        }
      )
    }
  }
</script>



// WEBPACK FOOTER //
// src/app/pages/CLO/Dashboard.vue